import React from 'react';

import { Container } from 'styles';
import { ColumnContentLarge, ColumnContentSmall } from 'styles/ColumnContent';
import SectionItem from 'components/layout/section-item/SectionItem';
import QuestionItem from 'components/layout/question-item/QuestionItem';
import * as S from './styles';
import Loading from 'components/layout/loading/Loading';

const UserTypeContent = ({ title, sections, articles }) => (
    <Container>
        <S.CustomColumnContent>
            <ColumnContentSmall>
                <S.UserTypeContentTitle>{title}</S.UserTypeContentTitle>
            </ColumnContentSmall>

            <ColumnContentLarge>
                <S.UserTypeContentSubtitle>Dúvidas comuns</S.UserTypeContentSubtitle>
                {articles.length === 0 ? (
                    <Loading />
                ) : (
                    <S.UserTypeContentGrid>
                        {articles.map(article => <QuestionItem key={article.id} url={article.url} title={article.title} type={article.categoryType} />)}
                    </S.UserTypeContentGrid>
                )}

                <S.UserTypeContentSubtitle>Sessões</S.UserTypeContentSubtitle>
                {articles.length === 0 ? (
                    <Loading />
                ) : (
                    <S.UserTypeContentGrid>
                        {sections.map(section => <SectionItem key={section.id} id={section.id} name={section.name} type={section.categoryType} />)}
                    </S.UserTypeContentGrid>
                )}
            </ColumnContentLarge>
        </S.CustomColumnContent>
    </Container>
);

export default UserTypeContent;